export class mdlSadadBillerRes{
    public  StatusCode : string;
    public  StatusDesc : string;
    public  StatusDescAr  : string;
    public  BillNo  : string;
    public BillExpiryDate: string;
    public  SurplusAmount :number;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlSadadBillerRes.ts